var _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPamant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 87,
    viewBox: "0 0 76 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 47,
    x2: 38,
    y2: -4.37114e-8,
    stroke: "black",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 47.75,
    x2: 52,
    y2: 47.75,
    stroke: "black",
    strokeWidth: 2.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 53.75,
    x2: 47,
    y2: 53.75,
    stroke: "black",
    strokeWidth: 2.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 59.75,
    x2: 44,
    y2: 59.75,
    stroke: "black",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPamant);
export default __webpack_public_path__ + "static/media/pamant.fbbc54a82f932f9b8e7fade011d9a2ca.svg";
export { ForwardRef as ReactComponent };